import React from 'react';

function Incorrect({ dir, onClick }) {
  return (
    <div className="questionContent questionUseMinDoctor questionIncorrect">
      <div className="questionTxt">
        <div className="questionPageTitle">
          <img src={dir + 'assets/img/ttl-incorrect.png'} alt="不正解" />
        </div>
        <div className="questionTxtInner">
          <div>
            ざんねんじゃが、はずれじゃ！
            <br />
            もう一度ヒントを見て考えてみるのじゃ！
            <br />
            おっと、のこり時間がへってしまったぞ！
            <br />
            まちがわないように注意するのじゃ！
          </div>
        </div>
        <button
          onTouchStart={() => {}}
          className="questionBtn questionBackBtn"
          onClick={() => {
            onClick(1);
          }}
        >
          <img src={dir + 'assets/img/btn-back.png'} alt="謎へ戻る" />
        </button>
      </div>
    </div>
  );
}

export default Incorrect;
